import { render } from "./newPrestation.vue?vue&type=template&id=5fd734a3&scoped=true"
import script from "./newPrestation.vue?vue&type=script&lang=js"
export * from "./newPrestation.vue?vue&type=script&lang=js"

import "./newPrestation.vue?vue&type=style&index=0&id=5fd734a3&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd734a3"]])

export default __exports__